import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';


module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (selectedMonth, pagination, search, sort, exclude, entities) => ({
        ...pagination,
        ...search,
        ...entities,
        ordering:       sort,
        exclude,
        selected_month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'cloudBillingVendors',
        endpoint:           endpoints.cloudBilling.vendorsEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            ...item,
            total:         item.total_selected_month,
            totalPrevious: item.total_previous_month,
            count:         item.count,
            results:       item.results.map(vendor => ({
                id:                    vendor.code,
                name:                  vendor.title,
                spending:              vendor.spending_selected_month,
                previousSpending:      vendor.spending_previous_month,
                spendingSelectedMonth: vendor.spending_selected_month,
                spendingPreviousMonth: vendor.spending_previous_month,
                vendor:                {
                    code: vendor.code,
                    name: vendor.title
                }
            }))
        })
    })
};




// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingVendors.js